//   selectVoucherStatus,

import {createSelector} from "@reduxjs/toolkit";
import {isEmpty} from "es-toolkit/compat";
import {
  allDataSelector,
  bloodAmountSettingsSelector,
  deliverySettingsSelector,
  formQuestionsSelector,
  partnerClinicsSelector,
  phlebotomyOptionsSelector,
  preBookSettingsSelector,
  referralCodeSettingsSelector,
  showDelayMessageSelector,
  showPinScreenSelector,
  subscriptionsCancelOptionsSelector,
  testKitSettingsSelector,
  voucherStatusSelector,
} from "./appSettingsSlice";

export const selectAllSettingsData = createSelector([allDataSelector], allData => (!isEmpty(allData) ? allData : {}));

export const selectVoucherStatus = createSelector([voucherStatusSelector], voucherStatus =>
  !isEmpty(voucherStatus) ? voucherStatus : {},
);

export const selectPartnerClinics = createSelector([partnerClinicsSelector], partnerClinics =>
  !isEmpty(partnerClinics) ? partnerClinics : [],
);

export const selectTestKitSettings = createSelector([testKitSettingsSelector], testKitSettings =>
  !isEmpty(testKitSettings) ? testKitSettings : {},
);

export const selectShowDelayMessage = createSelector([showDelayMessageSelector], showDelayMessage => showDelayMessage);

export const selectShowPinScreen = createSelector([showPinScreenSelector], showPinScreen => showPinScreen);

export const selectSubscriptionsCancelOptions = createSelector(
  [subscriptionsCancelOptionsSelector],
  subscriptionsCancelOptions => (!isEmpty(subscriptionsCancelOptions) ? subscriptionsCancelOptions : []),
);

export const selectBloodAmountSettings = createSelector([bloodAmountSettingsSelector], bloodAmountSettings =>
  !isEmpty(bloodAmountSettings) ? bloodAmountSettings : {},
);

export const selectDeliverySettings = createSelector([deliverySettingsSelector], deliverySettings =>
  !isEmpty(deliverySettings) ? deliverySettings : {},
);

export const selectFormQuestions = createSelector([formQuestionsSelector], formQuestions =>
  !isEmpty(formQuestions) ? formQuestions : [],
);

export const selectKitBaseCost = createSelector([testKitSettingsSelector], testKitSettings => {
  const kitCost = parseFloat(testKitSettings?.kitBaseCost);
  return !isNaN(kitCost) ? kitCost : 0;
});

export const selectIsOnline = createSelector([state => state], state => {
  return state.offline.online ?? true;
});

export const selectPhlebotomyOptions = createSelector([phlebotomyOptionsSelector], phlebotomyOptions =>
  !isEmpty(phlebotomyOptions) ? phlebotomyOptions : [],
);

export const selectPreBookSettings = createSelector([preBookSettingsSelector], preBookSettings =>
  !isEmpty(preBookSettings) ? preBookSettings : {},
);

export const selectSettingsMaxMonthsInAdvance = createSelector(
  [preBookSettingsSelector],
  preBookSettings => preBookSettings?.maxMonthsInAdvance || 0,
);

export const selectReferralCodeSettings = createSelector([referralCodeSettingsSelector], referralCodeSettings =>
  !isEmpty(referralCodeSettings) ? referralCodeSettings : {},
);

export const selectKitPrices = createSelector([testKitSettingsSelector], testKitSettings => {
  const kitPrices = testKitSettings?.kitPrices || [];
  return !isEmpty(kitPrices) ? kitPrices : [];
});

export const selectKitUpgradeCost = createSelector([testKitSettingsSelector], testKitSettings => {
  const kitUpgradeCost = testKitSettings?.kitUpgradeCost;
  return kitUpgradeCost ? kitUpgradeCost : 0;
});

export const selectSaasPrices = createSelector([allDataSelector], allData => {
  const saasPrices = allData?.saasPrices || {};
  const partnerDetails = allData?.partnerDetails || {};

  console.log("saasPrices: ", allData);
  const bespokeBaseCost =
    saasPrices?.bespokeBaseCost > 0 ? saasPrices.bespokeBaseCost : allData?.testKitSettings?.kitBaseCost || 0;

  return {
    bespokeBaseCost,
    gmcCost: saasPrices?.gmcCost > 0 ? saasPrices.gmcCost : 0,
    kitDispatchCost: saasPrices?.kitDispatchCost > 0 ? saasPrices.kitDispatchCost : 0,
  };
});
